//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Facebook from '../../svg/facebook.vue';
import Instagram from '../../svg/instagram.vue';
  export default {
    name: "index",
    components: { Facebook, Instagram }
}

